exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#teasers.side > .teasers .image > .thumb > img {\n  padding: 0 !important;\n}\n", ""]);

// exports
